import React, { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { Modal, Button } from "react-bootstrap";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import Spinner from "../components/Common/Spinner"; // optional
import Select from "react-select"
import { createNewAdmin, deleteAdmin, getSubAdmins, updateAdminInfo, updateAdminStatus, updatePermission } from "../../services/Admin/adminServices";

const AdminPage = () => {
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedAdmin, setSelectedAdmin] = useState(null); // null = add, object = edit
  const [permissionModal, setPermissionModal] = useState(false);
  const [selectedPermissions, setSelectedPermissions] = useState([]);

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="12" cy="5" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="19" r="2"></circle>
      </g>
    </svg>
  );

  const fetchAdmins = async () => {
    try {
      setLoading(true);

      const response =await getSubAdmins(0,100);
      setAdmins(response?.data?.data?.admins || []);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load admins");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAdmins();
  }, []);

  const handleDelete = async(id) => {
  try {
    await deleteAdmin(id);
    toast.success("Admin deleted");
    fetchAdmins();
  } catch (error) {
    toast.error(error?.response?.data?.message || "Failed to delete admin");
    console.error(error);
  }
  };

 



const handlestatus=async(id,status)=>{
try {
  const payload={adminId:id,isActive:status}
    await updateAdminStatus(payload);
    toast.success("Status updated successfully");
  fetchAdmins();
} catch (error) {
  toast.error(error?.response?.data?.message || "Failed to update status");
  console.error(error)
}
}




  

 

  const openModal = (admin = null) => {
    setSelectedAdmin(admin);
    setShowModal(true);
  };

  const openPermissionsModal = (admin) => {
    setSelectedAdmin(admin);
     setPermissionModal(true);
  }



  const AdminSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
   
  });

  const handleSubmit = async(values, { resetForm }) => {
   
    if (selectedAdmin) {

      const payload={
        name:values.name,
        email:values.email,
        permissions:values.permissions

      }


       await updateAdminInfo(selectedAdmin._id,payload);
      toast.success("Admin updated successfully");
      fetchAdmins();
    } else {
      await createNewAdmin(values);
      toast.success("Admin added successfully");
      resetForm();
      fetchAdmins();
    }
    setShowModal(false);
  };

const PERMISSIONS_MAP = {
  MANAGE_SERVICES: "manage_services",
  MANAGE_FAQ: "manage_faq",
  MANAGE_LEGAL_INFO: "manage_legal_info",
  MANAGE_RESOURCES: "manage_resources",
  MANAGE_EDUCATION: "manage_education",
  MANAGE_PRIVACY_POLICY: "manage_privacy_policy",
  MANAGE_TERMS_CONDITIONS: "manage_terms_conditions",
  MANAGE_ABOUT: "manage_about",
  MANAGE_PROMOTIONS: "manage_promotions",
  MANAGE_SEARCH: "manage_search",
  MANAGE_USERS: "manage_users",
  VIEW_USERS: "view_users",
  MANAGE_ADMINS: "manage_admins",
  CREATE_SUB_ADMIN: "create_sub_admin",
  MANAGE_UPLOADS: "manage_uploads",
  MANAGE_SETTINGS: "manage_settings",
  VIEW_ANALYTICS: "view_analytics",
  MANAGE_CASE_REFERRALS: "manage_case_referrals",
  MANAGE_APPOINTMENTS: "manage_appointments",
  MANAGE_DEPARTMENTS: "manage_departments",
};
const PERMISSIONS = Object.entries(PERMISSIONS_MAP).map(([key, value]) => ({
  label: key.replace(/_/g, " "), // "MANAGE_SERVICES" → "MANAGE SERVICES"
  value: value,                  // "manage_services"
}));

const getPermissionLabel = (permValue) => {
  const found = PERMISSIONS.find((p) => p.value === permValue);
  if (found) return found.label;
  return permValue ? permValue.replace(/_/g, " ").toUpperCase() : "";
};


  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 style={{ color: "#0AB7EA" }}>Admin Management</h2>
        <Button
          style={{ backgroundColor: "#0AB7EA", border: "none" }}
          onClick={() => openModal()}
        >
          Add New Admin
        </Button>
      </div>

      {loading ? (
        <Spinner />
      ) : (
        <table className="table table-striped align-middle shadow-sm">
          <thead className="table-light">
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Permissions</th>
              <th>Status</th>
              <th style={{ textAlign: "center" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {admins?.length > 0 ? (
              admins.map((admin, index) => (
                <tr key={admin._id || index}>
                  <td>{admin.name}</td>
                  <td>{admin.email}</td>
                  <td>{admin.permissions?.map((d)=>{
                    return <span key={d} className="badge bg-info me-1 mb-1">{getPermissionLabel(d)}</span>
                  })}</td>
                  <td>
                    <span
                      className={`badge ${
                        admin.isActive === true ? "bg-success" : "bg-danger"
                      }`}
                    >
                      {admin.isActive === true ? "Active" : "Suspended"}
                    </span>
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="light"
                        id={`dropdown-basic-${index}`}
                        style={{ padding: "4px 8px" }}
                      >
                        {svg1}
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => openModal(admin)}>
                          Edit
                        </Dropdown.Item>
                   
                        <Dropdown.Item
                          onClick={() => openPermissionsModal(admin)}
                        >
                          Permissions
                        </Dropdown.Item>

                         {admin.isActive ? (
                        <Dropdown.Item onClick={() => handlestatus(admin._id,false)}>
                          Suspend
                        </Dropdown.Item>
                        ) : (
                           <Dropdown.Item onClick={() => handlestatus(admin._id,true)}>
                          Enabe
                        </Dropdown.Item>
                        )}
     <Dropdown.Item onClick={() => handleDelete(admin._id)}>
                          Delete
                        </Dropdown.Item>
                       
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center">
                  No admins found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}

  
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{selectedAdmin ? "Edit Admin" : "Add Admin"}</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={
            selectedAdmin || { name: "", email: "", password: "" ,    permissions: [] }
          }
          validationSchema={AdminSchema}
          onSubmit={handleSubmit}
        >
          {({ errors, touched ,values,setFieldValue}) => (
            <FormikForm>
              <Modal.Body>
                <div className="mb-3">
                  <label className="form-label">Name</label>
                  <Field
                    name="name"
                    className={`form-control ${
                      errors.name && touched.name ? "is-invalid" : ""
                    }`}
                  />
                  <ErrorMessage
                    name="name"
                    component="div"
                    className="text-danger"
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <Field
                    name="email"
                    type="email"
                    className={`form-control ${
                      errors.email && touched.email ? "is-invalid" : ""
                    }`}
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="text-danger"
                  />
                </div>


                {selectedAdmin ? null : (

                <div className="mb-3">
                  <label className="form-label">Password</label>
                   <Field
                    name="password"
                    type="password"
                    className={`form-control ${
                      errors.email && touched.email ? "is-invalid" : ""
                    }`}
                  />
                  {/* <ErrorMessage
                    name="password"
                    component="div"
                    className="text-danger"
                  /> */}
                </div>
                )}


 {/* <div className="mb-3">
                  <label className="form-label">Role</label>
                  <Field as="select" name="role" className="form-select">
                    <option value="admin">admin</option>
                    <option value="subadmin">sub admin</option>
                  </Field>
                </div> */}

<div className="mb-3">
  <label className="form-label">Permissions</label>
  <Field name="permissions">
    {({ field, form }) => (
      <Select
        isMulti
        options={PERMISSIONS}
        classNamePrefix="select"
        placeholder="Select permissions..."
        value={PERMISSIONS.filter((option) =>
          field.value.includes(option.value)
        )}
        onChange={(selected) =>
          form.setFieldValue(
            "permissions",
            selected.map((opt) => opt.value)
          )
        }
        onBlur={() => form.setFieldTouched("permissions", true)}
      />
    )}
  </Field>
  {/* <ErrorMessage
    name="permissions"
    component="div"
    className="text-danger"
  /> */}
</div>


        {/* Debug preview (optional) */}
        {/* <pre>{JSON.stringify(values.permissions, null, 2)}</pre> */}




              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowModal(false)}>
                  Close
                </Button>
                <Button
                  type="submit"
                  style={{ backgroundColor: "#0AB7EA", border: "none" }}
                >
                  {selectedAdmin ? "Save Changes" : "Add Admin"}
                </Button>
              </Modal.Footer>
            </FormikForm>
          )}
        </Formik>
      </Modal>


     <Modal show={permissionModal} onHide={() => setPermissionModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Manage Permissions</Modal.Title>
  </Modal.Header>

  <Formik
    initialValues={
     { adminId: selectedAdmin ? selectedAdmin._id : "",
      permissions: selectedAdmin ? selectedAdmin.permissions : []}
    }
    onSubmit={(values) => {

      updatePermission(values);
      

      setPermissionModal(false); // close modal after save
            fetchAdmins();
            toast.success("Permissions updated successfully");
    }}
  >
    {({ values, setFieldValue }) => (
      <FormikForm>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">Permissions</label>
            <Field name="permissions">
              {({ field, form }) => (
                <Select
                  isMulti
                  options={PERMISSIONS}
                  classNamePrefix="select"
                  placeholder="Select permissions..."
                  value={PERMISSIONS.filter((option) =>
                    field.value.includes(option.value)
                  )}
                  onChange={(selected) =>
                    form.setFieldValue(
                      "permissions",
                      selected.map((opt) => opt.value)
                    )
                  }
                  onBlur={() => form.setFieldTouched("permissions", true)}
                />
              )}
            </Field>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setPermissionModal(false)}>
            Close
          </Button>
          <Button
            type="submit"
            style={{ backgroundColor: "#0AB7EA", border: "none" }}
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </FormikForm>
    )}
  </Formik>
</Modal>





    </div>
  );
};

export default AdminPage;
